<div class="address_body">
  <h3>Change property type and size</h3>
  <p>What type of a property are you looking to cover?</p>
  <span (click)="close()" class="close">
    <img src="https://cdn.elitehw.com/images/cross.webp" alt="cross" title="cross"/>
  </span>

  <div class="formarea">
    <form [formGroup]="propertyForm">
      <!-- <div class="inputprt">
        <select formControlName="selectedPropertyType" (ngModelChange)="propertyTypeChange($event)">
          <option value="">Select property type</option>
          <option
            *ngFor="let item of data?.propertyTypeArray"
            [value]="item?.title"
          >
            {{ item?.title }}
          </option>
          <mat-error *ngIf="propertyForm.get('selectedPropertyType')?.hasError('required') && propertyForm.get('selectedPropertyType')?.touched">
            Please select a property type.
        </mat-error>
        </select>
      </div> -->
      <div class="inputprt">
        <mat-form-field appearance="outline">
          <mat-select formControlName="selectedPropertyType" (selectionChange)="propertyTypeChange($event)">
          <mat-option value="">Select property type</mat-option>
          <mat-option *ngFor="let item of data?.propertyTypeArray" [value]="item.title">{{ item?.title }}</mat-option>
          </mat-select>
          <mat-error *ngIf="propertyForm.get('selectedPropertyType')?.hasError('required') && propertyForm.get('selectedPropertyType')?.touched">
            Please select a property type.
        </mat-error>
        </mat-form-field>
      </div>
      <!-- <div class="inputprt">
        <select formControlName="selectedPropertySize" >
          <option value="">Select property size</option>
          <option
            *ngFor="let item of propertySize"
            [value]="item.title"
          >
            {{ item?.title }}
          </option>
        </select>
        <mat-error *ngIf="propertyForm.get('selectedPropertySize')?.hasError('required') && propertyForm.get('selectedPropertySize')?.touched">
          Please select a property size.
      </mat-error>
      </div> -->
      <div class="inputprt">
        <mat-form-field appearance="outline">
          <mat-select formControlName="selectedPropertySize">
          <mat-option value="">Select property size</mat-option>
          <mat-option *ngFor="let item of propertySize" [value]="item.title">{{ item?.title }}</mat-option>
          </mat-select>
          <mat-error *ngIf="propertyForm.get('selectedPropertySize')?.hasError('required') && propertyForm.get('selectedPropertySize')?.touched">
            Please select a property size.
        </mat-error>
        </mat-form-field>
      </div>
      <div class="button_area">
        <button (click)="close()" class="cancel">Cancel</button>
        <button (click)="update()" class="updatebtn">Update</button>
      </div>
    </form>
  </div>
</div>

